<div class="flex card-container">
  @for (card of cards$ | async; track card) {
    <div
      class="image-card flex-1 nordic-blue-900-bg rounded-large white-text flex flex--align-end relative overflow-hidden"
    >
      <div class="absolute fill grow">
        <fin-content-image
          *ngIf="card.media?.[0]"
          [imageData$]="card.media[0] | finToObservable"
          [fillParent]="true"
        ></fin-content-image>
        <div class="absolute fill gradient"></div>
      </div>
      <div class="flex fill flex--space-between z1 ps-large-x pr-medium-b">
        <div>
          <div class="font-body-1 bold-type">{{ card.teaserTitle }}</div>
          <h3 class="heading-3">{{ card.teaserText | finStripHtml }}</h3>
        </div>
        <div class="flex flex--align-end">
          <fcom-icon-button
            [icon]="{ name: SvgLibraryIcon.ARROW_RIGHT }"
            [theme]="IconButtonTheme.LIGHT_SECONDARY_OUTLINE"
            [size]="IconButtonSize.LARGE"
            [aria]="{ label: card.teaserText }"
            [href]="card.related?.[0]?.target?.url"
            [externalLink]="card.related?.[0]?.target?.openInNewTab"
            (clickBtn)="trackEvent(card)"
          ></fcom-icon-button>
        </div>
      </div>
    </div>
  }
</div>
